import React, { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

const CardComponent: React.FC<CardProps> = ({ children, className = '', onClick }) => {
  return (
    <div onClick={onClick} className={`shadow-sm rounded-md border ${className} bg-cardClr text-cardClr-text border-none`}>
      {children}
    </div>
  );
};

export default CardComponent;
